import React from "react";
import IKit_Builder_Option_ItemUI from "../../../../../../../../models/IKit_Builder_Option_ItemUI";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import "./CatalogItemKitBuilderSubItem.scss";

type Props = {
    subItem: IKit_Builder_Option_ItemUI | Partial<IKit_Builder_Option_ItemUI>;
    removeSubItemFn: (subItem: IKit_Builder_Option_ItemUI | Partial<IKit_Builder_Option_ItemUI>) => void;
    id: string;
    isActive?: boolean;
    isDragOverlay?: boolean;
};

export const CatalogItemKitBuilderSubItem = (props: Props) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
        id: props.id,
        data: {
            type: "kit-builder-sub-item",
        },
    });

    const style = props.isDragOverlay
        ? {
              position: "relative" as const,
              zIndex: 1000,
              opacity: 0.9,
          }
        : {
              transform: CSS.Transform.toString(transform),
              transition,
              opacity: isDragging ? 0.6 : 1,
              position: "relative" as const,
              zIndex: isDragging ? 1 : "auto",
          };

    const activeStyles = props.isActive
        ? {
              background: "#f7f9fc",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.15)",
              border: "1px dashed #007bff",
              borderRadius: "4px",
              padding: "4px",
          }
        : {};

    const overlayStyles = props.isDragOverlay
        ? {
              background: "#ffffff",
              boxShadow: "0 5px 16px rgba(0, 0, 0, 0.2)",
              opacity: 0.9,
              border: "1px solid #007bff",
              borderRadius: "4px",
              padding: "4px",
          }
        : {};

    return (
        <div
            className={"CatalogItemKitBuilderSubItem"}
            ref={setNodeRef}
            style={{ ...style, ...activeStyles, ...overlayStyles }}
            {...attributes}>
            <div className={"d-flex align-items-center"}>
                <div className="drag-handle me-2" {...listeners}>
                    <i className="fas fa-grip-lines" />
                </div>
                <i className={"fas fa-trash-alt text-danger me-2 pointer"} onClick={() => props.removeSubItemFn(props.subItem)} />
                <span className={props.subItem.deleteFlag ? "text-strikethrough" : ""}>{props.subItem.Catalog_Item?.name}</span>
            </div>
        </div>
    );
};
